import { type AggResponse, fetchAgg } from '../../../common/utils/fetch-agg';
import { inMemoryCache } from '../../../utils/caching/in-memory';

export const positionTeamsCache = inMemoryCache<AggResponse<PositionTeamsResponse>>();

const QUERY_NAME = 'PositionTeams';
const positionTeamsQueryString = `query ${QUERY_NAME}($cloudId: ID!, $fieldId: ID!, $rql: String, $after: String, $first: Int) {
  radar_fieldValues(
    cloudId: $cloudId
    uniqueFieldId: $fieldId
    rql: $rql
    first: $first
    after: $after
  ) { 
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      cursor
      node {
        __typename
        __isRadarFieldValue: __typename
        ... on RadarAriFieldValue {
          __typename
          isRestricted
          ari
          value {
            __typename
            ... on TeamV2 {
              __typename
              displayName
              id
              organizationId
              smallAvatarImageUrl
            }
          }
        }
      }
    }
  }
}`;

export type PositionTeam = {
	cursor: string;
	node: {
		isRestricted: boolean;
		ari: string;
		value: {
			__typename: string;
			displayName: string;
			id: string;
			organizationId: string;
			smallAvatarImageUrl: string;
		};
	};
};

export type PositionTeamsResponse = {
	radar_fieldValues: {
		edges?: PositionTeam[];
	};
};

export type PositionTeamsQueryVariables = {
	cloudId: string;
	first: number;
	fieldId: string;
	rql: string;
	after?: string;
};

export const positionTeamsQuery = (cloudId: string, first = 20, rql: string, after?: string) => {
	const fieldId = 'team';
	return positionTeamsCache.inMemoryDecorator(
		[cloudId, first, rql, fieldId, after].filter(Boolean).join('-'),
		async () => {
			if (!cloudId) {
				return {
					data: {
						radar_fieldValues: {
							edges: [],
						},
					},
				};
			}

			const response = await fetchAgg<PositionTeamsQueryVariables, PositionTeamsResponse>({
				graphQuery: positionTeamsQueryString,
				variables: { cloudId, first, rql, fieldId, after },
				operationName: QUERY_NAME,
			});

			const hasErrors = response.errors?.some((error) => error);

			if (hasErrors) {
				return Promise.reject(response);
			}
			return response;
		},
	);
};
